const styles = {
    cutOffDates: {
        backgroundColor: "im_light_blue.500",
        color: "im_grey.200",
    },
};

export default styles;
